import {
  VIEW_PAGE,
  VIEW_PAGE_IN_BACKGROUND,
} from "./../analytics/analyticsevents";

import URLRouter from "./../utilities/URLRouter";

/**
 * Contains shared functions between readers
 * @type {Object}
 */
const readerMixin = {
  /* *
   * Triggers correct page view event depending on ALB is opened or not
   */
  triggerPageViewEvent() {
    const analyticEvent = URLRouter.isAlbURL()
      ? VIEW_PAGE_IN_BACKGROUND
      : VIEW_PAGE;
    this._appState.triggerEvent(
      analyticEvent,
      { mode: this._appState.isDoublePage ? "double page" : "single page" },
      true
    );
  },
};

export default readerMixin;



// WEBPACK FOOTER //
// ./src/common/components/readerMixin.js